// used in:
// app-template/AppHeader.js
// app-template/AppNavigation.js
// app-template/AppFooter.js
// folio-landing/LandingIEP.js
// folio-landing/LandingIgluSearch.js
// folio-landing/LandingIgluCabin.js
// folio-case-study-cs/CabinView.js
// about/AboutView.js

const FolioHome = {
	linkName: "Overview",
	path: "/",
	addClassName: "link",
};
const FolioIngenio = {
	caseStudy: "Pharmacy benefits application",
	tag01: "IngenioRx",
	tag02: "Enterprise applications",
	tag03: "User-flow",
	tag04: "Case study",
	path: "/ingenio-eligibility-application",
	pathTemp: "/anthem-ingenio-eligibility-application",
	addClassName: "link case-study",
};
const FolioSearch = {
	caseStudy: "Searching for a cruise holiday",
	tag01: "Iglu Cruise",
	tag02: "E-commerce",
	tag03: "User-flow",
	tag04: "Case study",
	tag05: "Search",
	path: "/iglu-search-for-a-cruise-holiday",
	addClassName: "link case-study",
};
const FolioCabin = {
	caseStudy: "Customising a cruise holiday user-flow",
	tag01: "Iglu Cruise",
	tag02: "E-commerce",
	tag03: "User-flow",
	tag04: "Case study",
	path: "/iglu-cabin-selection",
	addClassName: "link case-study",
};
const FolioAbout = {
	linkName: "About me",
	path: "/about-me",
	addClassName: "link",
};
const FolioResume = {
	linkName: "Resume",
	path: "/resume",
	addClassName: "link",
};

export {
	FolioHome,
	FolioIngenio,
	FolioSearch,
	FolioCabin,
	FolioAbout,
	FolioResume,
};
